import React from 'react';
import { motion } from 'framer-motion';

export const CandidateMagnetAnimation = () => {
  return (
    <div className="relative w-full h-[250px] bg-white rounded-xl overflow-hidden p-6 flex flex-col justify-between border border-brand-offwhite shadow-inner">
      {/* Subtle Dot Grid Background */}
      <motion.div 
        className="absolute inset-0 z-0 opacity-30"
        style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, #5851D3 1.5px, transparent 0)',
          backgroundSize: '24px 24px',
        }}
        animate={{
          backgroundPosition: ['0px 0px', '24px 24px'],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      
      {/* Gradient mask to fade out edges of the grid */}
      <div className="absolute inset-0 z-0 bg-[radial-gradient(circle_at_center,transparent_10%,white_80%)]" />

      <div className="relative z-10 flex-1 flex flex-col items-center justify-center">
        <motion.div
          initial={{ scale: 0.9, opacity: 0, y: 10 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="text-center"
        >
          <h4 className="text-6xl md:text-7xl font-bold text-brand-blue tracking-tight mb-2 drop-shadow-sm">
            4M+
          </h4>
          <p className="text-base md:text-lg font-medium text-brand-darkgrey">
            premium tech professionals
          </p>
        </motion.div>
      </div>

      {/* Bottom text */}
      <div className="relative z-10 text-center mt-4">
        <p className="text-sm font-medium text-brand-grey italic">
          "Every 3rd high-skill developer in India is on Cutshort"
        </p>
      </div>
    </div>
  );
};
